import { FormArray, FormGroup } from '@angular/forms';

export function getAllErrors(form: FormGroup | FormArray): Record<string, unknown> {
  const errors: Record<string, unknown> = {};

  Object.keys(form.controls).forEach((key) => {
    const control = form.get(key);

    if (control instanceof FormGroup || control instanceof FormArray) {
      const childErrors = getAllErrors(control);
      if (Object.keys(childErrors).length > 0) {
        errors[key] = childErrors;
      }
      return;
    }

    if (control?.errors) {
      errors[key] = control.errors;
    }
  });

  return errors;
}
